export default "__VITE_ASSET__CrvJwK40__"